import { Bean, FormContextValues, ValidationRules } from '@dreryk/react-common';
import { Textarea } from '@dreryk/react-components';

import { visitDetailsTranslationKeys } from '../../../../../../../translations';

const MAXIMUM_LENGTH_OF_REASON_CONTENT = 200;
const CHRONIC_DISEASE_REMOVAL_REASON_FIELD_NAME = 'chronicDiseaseRemovalReason';

const VALIDATION_RULES: ValidationRules<Bean> = {
   required: true,
   maxLength: MAXIMUM_LENGTH_OF_REASON_CONTENT,
};

export type ChronicDiseaseRemovalReasonFormBeanPart = {
   [CHRONIC_DISEASE_REMOVAL_REASON_FIELD_NAME]: string | null;
};

type RemovalReasonTextareaProps = Pick<FormContextValues<ChronicDiseaseRemovalReasonFormBeanPart>, 'register'>;

export const RemovalReasonTextarea = (props: RemovalReasonTextareaProps): JSX.Element => {
   return (
      <Textarea
         controller={props.register(CHRONIC_DISEASE_REMOVAL_REASON_FIELD_NAME, VALIDATION_RULES)}
         rows={3}
         maxRows={3}
         maxLength={MAXIMUM_LENGTH_OF_REASON_CONTENT}
         label={visitDetailsTranslationKeys.diagnoses.removalChronicDisease.form.chronicDiseaseRemovalReason.label}
         placeholder={
            visitDetailsTranslationKeys.diagnoses.removalChronicDisease.form.chronicDiseaseRemovalReason.placeholder
         }
         testId={'chronicDiseaseRemovalReason'}
      />
   );
};
